import { Button, styled } from '@mui/material';

export const StyledButton = styled(Button)(({ theme }) => ({
  '&>*+*': {
    marginLeft: '0.5rem',
  },
}));
